const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "CreatorName",
    label: "创建人",
    columnwidth: 160,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 80,
  },
  {
    prop: "OperateName",
    label: "操作",
    columnwidth: 100,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 90,
  },
  {
    prop: "RejectReason",
    label: "驳回原因",
    columnwidth: 150,
  },
  {
    prop: "CusName",
    label: "经销商名称",
    columnwidth: 220,
  },
  {
    prop: "TXCusName",
    label: "下级经销商",
    columnwidth: 230,
  },
  {
    prop: "ProviderName",
    label: "采购代理",
    columnwidth: 160,
  },
  {
    prop: "HPName",
    label: "医院名称",
    columnwidth: 160,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 160,
  },
  {
    prop: "VouchValiDate",
    label: "备案有效期",
    columnwidth: 120,
  },
  {
    prop: "CreateTime",
    label: "创建开始时间",
    columnwidth: 150,
    options: {
      type: "备案",
    },
  },
  {
    prop: "RejecterName",
    label: "驳回人",
    columnwidth: 170,
  },
  {
    prop: "RejectTime",
    label: "驳回时间",
    columnwidth: 120,
  },
  {
    prop: "UpdaterName",
    label: "修改人",
    columnwidth: 160,
  },
  {
    prop: "UpdateTime",
    label: "修改时间",
    columnwidth: 120,
  },
  {
    prop: "ID",
    label: "申请单号",
    columnwidth: 170,
  },
  // {
  //   prop: "ProviderType",
  //   label: "停启用人",
  //   columnwidth: 230,
  // },

  // {
  //   prop: "HasHPInvoiceName",
  //   label: "停启用时间",
  //   columnwidth: 160,
  // },
];
export default headerData;
